<template>
  <div style="display:flex; min-height:100vh; position:relative;">

    <Sidebar :is-open="sidebarOpen" @close="sidebarOpen = false" />
    <button
      v-show="!sidebarOpen"
      class="sidebar-toggle-btn"
      @click="sidebarOpen = true"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <div
      class="main-content-area"
    >
      <TopNavigation />

      <div class="page-body">
        <router-view />
      </div>
    </div>

  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue';
import TopNavigation from '../components/Topnav.vue';
export default {
  name: 'MainLayout',
  components: { Sidebar,
     TopNavigation
   },
  data() {
    return { sidebarOpen: true }
  }
}
</script>

<style scoped>
.main-content-area {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.2s ease;
}

.page-body {
  flex: 1;
  overflow-y: auto;
}

</style>